// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1RdSM","rootCenter":"LoadMoreObserver_rootCenter__8QIlI","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1lu0J"};